import React from 'react';

import EditReceiptForm from '../../Forms/EditReceiptForm';
import SubmitCancelButtonGroup from '../../SubmitCancelButtonGroup';
import GenericModal from '../GenericModal';

const ReceiptEditModal = props => {
  const { t, visible, onCancel, onSubmit, isSubmitting, formInstance, initialValues } = props;

  return (
    <GenericModal
      destroyOnClose
      title={t('updateReceipt')}
      visible={visible || isSubmitting}
      onCancel={onCancel}
      footer={
        <SubmitCancelButtonGroup
          loading={isSubmitting}
          disabled={isSubmitting}
          onCancel={onCancel}
          onSubmit={onSubmit}
          submitText={t('update')}
        />
      }
    >
      <EditReceiptForm
        t={t}
        isSubmitting={isSubmitting}
        formInstance={formInstance}
        initialValues={initialValues}
        isUpdate={true}
      />
    </GenericModal>
  );
};

export default ReceiptEditModal;
